<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">
            <el-form-item label="技能" prop="name">
                <el-input
                        v-model="form.name"
                        placeholder="请输入技能"
                        maxlength="10"
                        show-word-limit>
                </el-input>
            </el-form-item>
            <el-form-item label="掌握程度" prop="level">
                <el-radio v-model="form.level" v-for="item in levelOptions" :key="item.value" :label="item.value" border>{{ item.label }}</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="updateSkill()" v-if="editStatus.status==true">更新保存</el-button>
                <el-button type="primary" @click="saveSkill()" v-else>保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                    @confirm="cancel()"
                    placement="top-start"
                    icon="el-icon-info"
                    icon-color="red"
                    class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {saveSkill,updateSkill} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'skillForm',
        props: ['form','resumeId','editStatus'],
        data() {
            return {
//                form: {},
                levelOptions: [],   // 掌握程度
                rules: {
                    name: [
                        {required: true, message: '请输入技能/语言'},
                        {max: 30},
                    ],
                    level: [
                        {required: true, message: '请选择掌握程度'},
                    ]
                }
            }
        },
        created() {
            this.loadDictData();
        },
        methods: {
            /** 获取字典数据 */
            loadDictData() {
                getTreeListByDictType("mastery").then(response => {
                    this.levelOptions = response.data;
                });
            },
            saveSkill() {
                this.$refs["form"].validate(valid => {
                    if(valid) {
                        this.form.resumeId = this.resumeId;
                        saveSkill(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历专业技能保存失败");
                        })
                    }
                })
            },
            updateSkill() {
                this.$refs["form"].validate(valid => {
                    if(valid) {
                        this.form.resumeId = this.resumeId;
                        updateSkill(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历专业技能保存失败");
                        })
                    }
                })
            },
            // 简历工作经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeSkillEditStatus', false);
            }
        }
    };
</script>
<style>
    .el-radio.is-bordered+.el-radio.is-bordered{
        margin-left: 0px;
    }
</style>
